(function bbCartTierSwitch(globalScope) {
  'use strict';

  var VERSION = '1.1.0';

  function optionName(option) {
    return typeof option === 'string' ? option : option && option.name;
  }

  function variantOptions(variant) {
    if (Array.isArray(variant && variant.options)) return variant.options;
    return [variant && variant.option1, variant && variant.option2, variant && variant.option3].filter(function (value) {
      return value != null;
    });
  }

  function parseTierLabel(label) {
    var text = String(label || '').replace(/,/g, '').trim();
    var range = text.match(/(\d+)\s*[-–—]\s*(\d+)/);
    if (range) {
      return { min: Number(range[1]), max: Number(range[2]) };
    }

    var plus = text.match(/(\d+)\s*\+/);
    if (plus) {
      return { min: Number(plus[1]), max: Infinity };
    }

    // single quantity tier, e.g. "1 unit" or "1 unit ($8.99 ea)"; only a leading number counts
    var single = text.match(/^(\d+)(?!\d)/);
    if (single) {
      return { min: Number(single[1]), max: Number(single[1]) };
    }

    return null;
  }

  function bulkOptionIndex(product) {
    var options = Array.isArray(product && product.options) ? product.options : [];
    for (var index = 0; index < options.length; index += 1) {
      if (String(optionName(options[index]) || '').trim().toLowerCase() === 'bulk pricing') return index;
    }
    return -1;
  }

  function findTierVariant(product, currentVariantId, quantity) {
    var wantedQuantity = Number(quantity);
    var tierIndex = bulkOptionIndex(product);
    var variants = Array.isArray(product && product.variants) ? product.variants : [];
    var current = variants.find(function (variant) {
      return String(variant.id) === String(currentVariantId);
    });

    if (tierIndex < 0 || !current || !Number.isFinite(wantedQuantity) || wantedQuantity < 1) return null;

    var currentOptions = variantOptions(current);
    return variants.find(function (variant) {
      if (variant.available === false) return false;
      var options = variantOptions(variant);
      var tier = parseTierLabel(options[tierIndex]);
      if (!tier || wantedQuantity < tier.min || wantedQuantity > tier.max) return false;

      for (var optionIndex = 0; optionIndex < currentOptions.length; optionIndex += 1) {
        if (optionIndex !== tierIndex && options[optionIndex] !== currentOptions[optionIndex]) return false;
      }
      return true;
    }) || null;
  }

  function stableProperties(properties) {
    var source = properties && typeof properties === 'object' ? properties : {};
    return Object.keys(source).sort().map(function (key) {
      return [key, String(source[key])];
    });
  }

  function sameProperties(left, right) {
    return JSON.stringify(stableProperties(left)) === JSON.stringify(stableProperties(right));
  }

  function sellingPlanId(item) {
    var allocation = item && item.selling_plan_allocation;
    return allocation && allocation.selling_plan ? String(allocation.selling_plan.id) : '';
  }

  var helpers = {
    parseTierLabel: parseTierLabel,
    findTierVariant: findTierVariant,
    sameProperties: sameProperties,
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = helpers;
  if (!globalScope || !globalScope.customElements || !globalScope.fetch) return;

  var CartItemsElement = globalScope.customElements.get('cart-items');
  if (!CartItemsElement || !CartItemsElement.prototype) return;

  var cartPrototype = CartItemsElement.prototype;
  if (cartPrototype.__bbTierSwitchInstalled) return;

  Object.defineProperty(cartPrototype, '__bbTierSwitchInstalled', {
    configurable: false,
    enumerable: false,
    value: true,
  });

  var originalUpdateQuantity = cartPrototype.updateQuantity;
  var productCache = new Map();

  function routeRoot() {
    return globalScope.Shopify && globalScope.Shopify.routes && globalScope.Shopify.routes.root
      ? globalScope.Shopify.routes.root
      : '/';
  }

  function route(name, fallback) {
    return typeof routes !== 'undefined' && routes[name] ? routes[name] : routeRoot() + fallback;
  }

  async function responseJson(response) {
    var text = await response.text();
    var data;
    try {
      data = JSON.parse(text);
    } catch (error) {
      data = {};
    }

    if (!response.ok || data.status >= 400 || data.errors) {
      throw new Error(data.description || data.message || data.errors || 'The cart could not be updated.');
    }
    return data;
  }

  async function postCart(url, payload) {
    return responseJson(await globalScope.fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    }));
  }

  async function getCart() {
    return responseJson(await globalScope.fetch(route('cart_url', 'cart') + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }));
  }

  async function getProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);

    var request = responseJson(await globalScope.fetch(
      routeRoot() + 'products/' + encodeURIComponent(handle) + '.js',
      { credentials: 'same-origin', headers: { Accept: 'application/json' } }
    )).catch(function (error) {
      productCache.delete(handle);
      throw error;
    });

    productCache.set(handle, request);
    return request;
  }

  function sectionDefinitions(component) {
    try {
      return component.getSectionsToRender().filter(function (section) {
        return section && section.section && document.getElementById(section.id);
      });
    } catch (error) {
      return [];
    }
  }

  function renderSections(component, state, definitions) {
    definitions.forEach(function (section) {
      var root = document.getElementById(section.id);
      var html = state.sections && state.sections[section.section];
      if (!root || !html) return;

      var target = root.querySelector(section.selector) || root;
      try {
        target.innerHTML = component.getSectionInnerHTML(html, section.selector);
      } catch (error) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var source = parsed.querySelector(section.selector);
        if (source) target.innerHTML = source.innerHTML;
      }
    });

    component.classList.toggle('is-empty', state.item_count === 0);
    var cartFooter = document.getElementById('main-cart-footer');
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartFooter) cartFooter.classList.toggle('is-empty', state.item_count === 0);
    if (cartDrawer) cartDrawer.classList.toggle('is-empty', state.item_count === 0);
  }

  function showCartError(component, line, error) {
    var input = document.getElementById('Quantity-' + line) || document.getElementById('Drawer-quantity-' + line);
    if (input) input.value = input.getAttribute('value');
    var message = globalScope.cartStrings && globalScope.cartStrings.error
      ? globalScope.cartStrings.error
      : 'There was a problem updating your cart. Please try again.';
    try {
      component.updateLiveRegions(line, message);
    } catch (regionError) {
      var errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = message;
    }
    console.error('BusinessBulk tier update failed:', error);
  }

  async function changeLine(key, quantity, extra) {
    return postCart(route('cart_change_url', 'cart/change'), Object.assign({
      id: key,
      quantity: quantity,
    }, extra || {}));
  }

  async function migrateTier(component, line, quantity, focusName, cart, item, targetVariant) {
    component.enableLoading(line);

    var definitions = sectionDefinitions(component);
    var sections = definitions.map(function (section) { return section.section; });
    var finalRequest = {
      sections: sections,
      sections_url: globalScope.location.pathname,
    };
    var planId = sellingPlanId(item);
    var existingTarget = cart.items.find(function (candidate) {
      return candidate.key !== item.key
        && String(candidate.variant_id) === String(targetVariant.id)
        && sameProperties(candidate.properties, item.properties)
        && sellingPlanId(candidate) === planId;
    });

    var rollback = null;
    var newKey = null;

    try {
      if (existingTarget) {
        var previousQuantity = existingTarget.quantity;
        await changeLine(existingTarget.key, quantity);
        newKey = existingTarget.key;
        rollback = function () { return changeLine(existingTarget.key, previousQuantity); };
      } else {
        var addItem = {
          id: Number(targetVariant.id),
          quantity: quantity,
          properties: item.properties || {},
        };
        if (planId) addItem.selling_plan = planId;

        var added = await postCart(route('cart_add_url', 'cart/add'), { items: [addItem] });
        newKey = added.items && added.items[0] ? added.items[0].key : null;
        if (newKey) rollback = function () { return changeLine(newKey, 0); };
      }

      var state;
      try {
        state = await changeLine(item.key, 0, finalRequest);
      } catch (removeError) {
        if (rollback) {
          try { await rollback(); } catch (rollbackError) { console.error('BusinessBulk cart rollback failed:', rollbackError); }
        }
        throw removeError;
      }

      renderSections(component, state, definitions);

      var newLineIndex = state.items.findIndex(function (candidate) {
        return String(candidate.variant_id) === String(targetVariant.id)
          && sameProperties(candidate.properties, item.properties)
          && sellingPlanId(candidate) === planId;
      });
      var newLine = newLineIndex >= 0 ? newLineIndex + 1 : line;
      try { component.updateLiveRegions(newLine, ''); } catch (error) {}

      var cartDrawer = document.querySelector('cart-drawer');
      var focusTarget = document.getElementById('Quantity-' + newLine)
        || document.getElementById('Drawer-quantity-' + newLine);
      if (focusTarget && focusName) {
        var focusControl = focusTarget.closest('.cart-item') && focusTarget.closest('.cart-item').querySelector('[name="' + focusName + '"]');
        if (focusControl) focusControl.focus();
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cartData: state,
          variantId: String(targetVariant.id),
        });
      } else if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    } catch (error) {
      showCartError(component, line, error);
    } finally {
      try { component.disableLoading(line); } catch (error) {}
    }
  }

  cartPrototype.updateQuantity = async function (line, quantity, name, variantId) {
    var wantedQuantity = Number.parseInt(quantity, 10);
    if (!Number.isFinite(wantedQuantity) || wantedQuantity < 1) {
      return originalUpdateQuantity.call(this, line, quantity, name, variantId);
    }

    var cart;
    var item;
    var product;
    var targetVariant;

    try {
      cart = await getCart();
      item = cart.items[Number(line) - 1];
      if (!item || !item.handle) return originalUpdateQuantity.call(this, line, quantity, name, variantId);

      product = await getProduct(item.handle);
      targetVariant = findTierVariant(product, item.variant_id, wantedQuantity);
    } catch (error) {
      console.warn('BusinessBulk tier lookup failed; using the standard cart update.', error);
      return originalUpdateQuantity.call(this, line, quantity, name, variantId);
    }

    if (!targetVariant || String(targetVariant.id) === String(item.variant_id)) {
      return originalUpdateQuantity.call(this, line, quantity, name, variantId);
    }

    return migrateTier(this, Number(line), wantedQuantity, name, cart, item, targetVariant);
  };

  globalScope.BBCartTierSwitch = {
    installed: true,
    version: VERSION,
  };
})(typeof window !== 'undefined' ? window : null);